export default "__VITE_ASSET__D$thkcC4__"